module.exports = __webpack_public_path__ + "static/media/0324_IMG_LES_ENSEIGNES_LE_CHARCUTIER_LETTRE_A_LETTRE.e63cd18b.webp";